import auth from './middleware/auth'
import Movements from '@/screens/movements'
import Transactions from '@/screens/movements/Transactions'
import OtherMovements from '@/screens/movements/OtherMovements'
import store from '@/store'

const routes = [
  {
    path: '/management-movements',
    name: 'Movements',
    component: {
      ...Movements,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'Movements') {
          const routes = {
            manager: 'MTransactions'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'Movements') {
          const routes = {
            manager: 'MTransactions'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'transactions',
        name: 'MTransactions',
        component: Transactions,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'other-movements',
        name: 'MOtherMovements',
        component: OtherMovements,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
